import { useRef, useState } from 'react';

export default function SliderPage({key,leftComponent, rightComponent, initalWidth}) {
    const pageRef = useRef(null);
    const [leftWidth, setLeftWidth] = useState(initalWidth || 50);
    const [isDragging, setIsDragging] = useState(false);

    const handlePointerMove = (event) => {
        if (!isDragging || !pageRef.current) return;

        const { left, width } = pageRef.current.getBoundingClientRect();
        const percentage = ((event.clientX - left) / width) * 100;
        setLeftWidth(Math.min(80, Math.max(20, percentage)));
    };

    const stopDragging = () => setIsDragging(false);

    return (
        <div
            key={key}
            ref={pageRef}
            className='w-full h-full flex overflow-hidden select-none secondary'
            onPointerMove={handlePointerMove}
            onPointerUp={stopDragging}
            onPointerLeave={stopDragging}
        >
            <div className='h-full overflow-auto' style={{ width: `${leftWidth}%` }}>
                {leftComponent}
            </div>
            <button
                type='button'
                role='separator'
                aria-label='Resize panels'
                aria-valuemin='20'
                aria-valuemax='80'
                aria-valuenow={leftWidth}
                className='w-1 shrink-0 cursor-col-resize border-0 bg-gray-300 p-0 hover:bg-gray-500 focus:bg-gray-500'
                onPointerDown={(event) => {
                    event.currentTarget.setPointerCapture(event.pointerId);
                    setIsDragging(true);
                }}
            />
            <div className='h-full min-w-0 flex-1 overflow-auto'>
                {rightComponent}
            </div>
        </div>
    );
}